module Sm.UI.Entry

open MobF
open Sm.Model.Record

type EntryComputed =
    abstract Memo: bool

module Accessor =
    let dueDate =
        let read = function
            | [Meta.Date date] -> Some date
            | _ -> None
        let write date =
            [Meta.Date date]
        Meta.makeAccessor "due-date" read write

    let memo =
        let read = function
            | [Meta.Bool true] -> Some true
            | _ -> None
        let write = function
            | true -> [Meta.Bool true]
            | false -> [Meta.Bool false]
        Meta.makeAccessor "memo" read write

let SetMemo = Accessor.memo.Set(true)

type IComputed with
    member computed.Entry = computed.Extend(fun state ->
        Computation.structural { new EntryComputed with
            member _.Memo =
                Accessor.memo.Get(state.Metadata)
                |> Option.defaultValue false
        }
    )
